
import { RevCardCarousel } from '@ds/components/CardCarousel'

import ArticleCard from '@article/components/Card'

import translations from './FeaturedArticles.translations'

export default {
  components: {
    ArticleCard,
    RevCardCarousel,
  },

  props: {
    articles: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
  },
}
